import { ArrowRight } from 'lucide-react'
/**
 * Onboarding banner for new users who haven't taken the diagnostic yet.
 * Shows in the dashboard when no diagnostic result exists.
 */

import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export function MwOnboardingBanner() {
  const { t: tMw } = useTranslation('mw')

  return (
    <div className="rounded-2xl overflow-hidden mb-6"
      style={{ background: 'linear-gradient(135deg, #131830 0%, #1e3a5f 50%, #2563EB 100%)' }}>

      <div className="p-6 sm:p-8">
        <h2 style={{ fontFamily: 'var(--mw-font-display)', fontSize: 'clamp(20px, 4vw, 26px)', fontWeight: 700, color: 'white', margin: '0 0 8px' }}>
          {tMw('onboarding.welcomeTitle')}
        </h2>
        <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.6)', margin: '0 0 24px', maxWidth: 480 }}>
          {tMw('onboarding.welcomeSubtitle')}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
          <Step num={1}
            title={tMw('onboarding.step1Title')} desc={tMw('onboarding.step1Desc')} active />
          <Step num={2}
            title={tMw('onboarding.step2Title')} desc={tMw('onboarding.step2Desc')} />
          <Step num={3}
            title={tMw('onboarding.step3Title')} desc={tMw('onboarding.step3Desc')} />
        </div>

        <div className="flex flex-col sm:flex-row gap-3">
          <Link to="/diagnostico"
            className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-xl no-underline"
            style={{ background: 'white', color: 'var(--mw-ink)', fontSize: 14, fontWeight: 600 }}>
            {tMw('onboarding.startDiagnostic')}
            <ArrowRight className="size-4" aria-hidden />
          </Link>
          <Link to="/calculadoras"
            className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-xl no-underline"
            style={{ background: 'rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.7)', fontSize: 14 }}>
            {tMw('onboarding.skipForNow')}
          </Link>
        </div>
      </div>
    </div>
  )
}

function Step({ num, title, desc, active }: {
  num: number; title: string; desc: string; active?: boolean
}) {
  return (
    <div className="flex gap-3 items-start">
      <div className="size-8 rounded-full flex items-center justify-center shrink-0"
        style={{ background: active ? '#2563EB' : 'rgba(255,255,255,0.1)', color: 'white', fontSize: 13, fontWeight: 700 }}>
        {num}
      </div>
      <div>
        <div style={{ fontSize: 13, fontWeight: 600, color: 'white' }}>{title}</div>
        <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)', marginTop: 2, lineHeight: 1.4 }}>{desc}</div>
      </div>
    </div>
  )
}
